import { render } from "./NotFound.vue?vue&type=template&id=939f2168&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=939f2168&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\hapiick-tracking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-939f2168"]])

export default __exports__